import { Injectable, inject } from '@angular/core';
import { canvasConverter, interconnectionConverter } from '@seu-converter';
import { OfferFormService, RequestService, StoreService } from '@seu-services';
import {
  SEU_API_ENDPOINTS,
  SeuCanvas,
  SeuInterconnection,
  SeuInterconnectionApi,
  SeuOffer,
} from '@seu-types';
import { cloneDeep } from 'lodash-es';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CanvasService {
  private readonly requestService = inject(RequestService);
  private readonly store = inject(StoreService);
  private readonly offerFormService = inject(OfferFormService);

  public async updateCanvas(
    offer: SeuOffer,
    interconnectionId: string,
    canvas: SeuCanvas
  ): Promise<SeuCanvas | null> {
    const endpoint = SEU_API_ENDPOINTS.canvas
      .replace(':offerId', offer.id)
      .replace(':interconnectionId', interconnectionId);

    const data = canvasConverter.toApi(canvas);

    const responseData = await firstValueFrom(
      this.requestService.post<SeuInterconnectionApi>(
        endpoint as SEU_API_ENDPOINTS,
        data
      )
    );

    if (responseData) {
      const updatedOffer = cloneDeep(offer);
      updatedOffer.interconnections = updatedOffer.interconnections.map(
        (item) => {
          if (item.id === interconnectionId) {
            return interconnectionConverter.fromApi(responseData);
          }
          return item;
        }
      );
      this.store.setActiveOffer(updatedOffer);
      this.offerFormService.init(updatedOffer);
      return interconnectionConverter.fromApi(responseData).canvas;
    }
    return null;
  }
}
